export const endpoints = {
  auth: {
    loginUserUrl: '/authentication/login-user',
    passwordlessLoginUrl: '/authentication/passwordless-login-customer',
    getUserUrl: '/authentication/user-details',
    passwordlessVerifyUrl: '/authentication/passwordless-verify',
    sendOtpUrl: '/authentication/send-otp',
    signupWithOtp: '/authentication/signup-with-otp',
    guestSignupWithOtp: '/authentication/guest-signup-with-otp',
    setUserAttributesUrl: '/authentication/set-user-attributes',
    setUserPasswordUrl: '/authentication/set-user-pwd',
    getVerifiedEmailAttributes: '/authentication/verify-email-attr',
    ResendEmailVerifyLink: '/authentication/resend-email-verify-link',
    socialSignup: '/authentication/online-social-signup',
    validateSocialCode: '/authentication/validate-social-code',
    linkGiftCard: 'authentication/link-gift-card',
  },
  menu: {
    getMenuUrl: 'menu',
    getPopularItems: 'menu/popular-items',
    getFavoriteItems: 'menu/items/favorite',
    getTags: 'menu/online-tag',
    getAllergens: 'menu/online-allergen',
    getSearchItems: 'menu/items/search',
    getMenus: 'menu/get/menus',
    getCompleteMenu: 'menu/get/website-menus',
    validateMenuVersion: 'menu/get/validate-menu-version',
  },
  cart: {
    cartItem: 'cart/cartItem',
    getCartUrl: 'cart',
    getCartsByTickets: 'cart/by-tickets',
    getCartsStatusByTickets: 'cart/status/by-tickets',
    checkoutCart: 'cart/checkout',
    updateCart: '/cart/online',
    updateCartCustomer: 'cart/update-cart-customer',
    getCartItem: 'cart/item-in-stock',
    getCartIsValid: 'cart/cart-is-valid',
    getNuggetCartIsValid: 'cart/nugget-cart-is-valid',
    getLocalCartIsValid: 'cart/local-cart-is-valid',
    getCartValidation: 'cart/get-cart-validation',
    createPayLayterOrder: 'cart/create-pay-later-order',
    sendEvent: 'cart/nugget/send-event',
    updateCartStatus: 'cart/nugget/update-cart-status',
  },
  restaurant: {
    restaurant: 'restaurant',
    categoryItems: 'menu/category',
    categoryItemsByMenu: 'menu/get-categories',
    itemDetail: 'menu/item',
    prepareCart: 'cart/prepare-cart',
    reorderItems: 'cart/reorder-items',
    getNearbyLocations: 'restaurant/nearby',
    getRestaurantTimings: '/restaurant/timing',
    getOnlineSettings: '/online-ordering-settings',
    getOnlineRestaurant: 'restaurant/homepage',
    itemDetailRestaurant: 'restaurant/item-detail-restaurant',
    getByAlias: 'restaurant/restaurant-by-alias',
    getTipsSettings: 'general-settings/online/restaurant-tip-settings',
    sendCapiEvent: '/restaurant/capi/event',
  },
  bookmark: {
    bookmark: 'bookmarks',
    getBookmark: 'bookmarks/user',
    deleteBookmark: 'bookmarks',
  },
  feedback: {
    reviews: 'feedback/reviews',
    postReview: 'feedback/restaurant',
    getReviews: 'feedback/restaurant',
  },
  checkout: {
    getStripeKey: 'webhook/online/get-stripe-key',
    createIntent: 'payment/intent',
    createIntentV2: 'payment/new/intent/v2',
    createReceipt: 'payment/online/receipt',
    findWebhook: 'webhook',
    getCheckoutToken: 'ticket/get-checkout-token',
  },
  ticket: {
    getOrder: 'ticket/get/order',
    getMyOrders: 'ticket/get/myorders',
    getTicketStatus: 'ticket',
    getOrderDelay: 'ticket/order-delay',
  },
  table: {
    reserveTable: 'table/reserve-table',
  },
  business: {
    getByAlias: 'business/business-by-alias',
    getAllBusiness: 'business/business-list',
  },
  loyalty: {
    getItems: 'loyalty/online-menu',
  },
  giftCards: {
    getAllByRestaurantId: 'marketing/gift-card/online/listing',
    getAllByUserId: 'marketing/gift-card/get-customer-gift-cards',
    getUserGiftCard: 'marketing/gift-card/online/get-user-gift',
    getGiftCardByGiftCardNumber: 'marketing/gift-card/online/get-gift-card',
    getGiftCardByPhoneNumber: 'marketing/gift-card/online/get-gift-cards',
    checkCardNumberAndPin: 'marketing/gift-card/check-card-number-and-pin',
    checkAndGetBalance: 'marketing/gift-card/check-and-get-balance',
    createUserGift: 'marketing/gift-card/online/create-user-gift',
    getRedeemToken: 'marketing/gift-card/online/get-redeem-token',
    updateUserGift: 'marketing/gift-card/online/update-user-gift',
    verifyPin: 'marketing/gift-card/check-balance',
    validateGiftcardToken: 'marketing/gift-card/validate-giftcard-token',
    validatePaymentToken: 'marketing/gift-card/validate-payment-token',
    createZeroDollarPayment: 'payment/zero-dollar-payment',
    sendGiftReceipt: 'marketing/gift-card/online/send-gift-receipt',
    getGiftCardByHash: 'marketing/gift-card/online/get-gift-card-by-hash',
  },
  otp: {
    sendOTP: 'otp/send-otp',
    verifyOTP: 'otp/verify-otp',
  },

  qr: {
    getQrData: 'qr/get-qr',
  },

  delivery: {
    createDelivery: 'delivery/create-doordash-delivery',
    getDelivery: 'delivery/get-doordash-delivery',
    createDeliveryQuote: 'kitchen-hub/create-delivery-quote',
    cancelDelivery: 'kitchen-hub/update-delivery-quote',
    getDeliveryStatus: 'kitchen-hub/get-delivery',
  },
  pushNotifiaction: {
    createSubscription: '/push-notifications/create-subscription',
    sendNotification: '/push-notifications/send-notification',
    sendSms: '/push-notifications/send-sms',
  },
  subscribe: {
    unsubscribe: '/unsubscribe-email',
  },
  campaigns: {
    getCustomerCampaigns: 'campaign/get-customer-campaigns',
  },
  tags: {
    getTagsAndAllergens: '/tags-allergens/online-get-data',
    saveTags: '/tags-allergens/:customerId/tags',
    saveAllergens: '/tags-allergens/:customerId/allergens',
    fetchSelecteddata: '/tags-allergens/customer-selected-data',
  },
  deal: {
    checkIsDealsAvailable: 'deal/online/is-available',
    getAvailableDeals: 'deal/online/available',
    getDealById: 'deal/online/details',
  },
  legals: {
    acceptAllLegals: '/user-legals/accept',
  },
};
